import { combineReducers } from 'redux';

//import { loginReducer as login } from '../components/containers/Login/Login.reducers';
import { AdminReducer as CRMMenu } from '../AdminReducer.component';
import { UserDetailReducer as allUserDetail } from '../AdminReducer.component';
import { DuePaymentReducer as duePayment } from '../AdminReducer.component';
import { DuePaymentEMIReducer as duePaymentEmi } from '../AdminReducer.component';
// import { UserDetail as userDetail } from '../components/containers/Dashboard/DashboardReducer.component';
// import { NotificationReducer as notification } from '../components/containers/Dashboard/DashboardReducer.component';
import { crmNotificationReducer as crmNotification } from '../AdminReducer.component';
import { IncomingPaymentReducer as incomingPayment } from '../AdminReducer.component';
import { LatestDocUploadReducer as latestDocUpload } from '../AdminReducer.component';
import { LEadByMobileNumber as leadByNumber } from '../AdminReducer.component';
import { LoanApprovalLead as loanApprovalLead } from '../AdminReducer.component';
import { loanApprovalLeadGiftCard as loanApprovalLeadGiftCard } from '../AdminReducer.component';

import { LoanAddaLeads as loanAddaLeadData } from '../AdminReducer.component';
import { LoanApprovalLeadByPriority as loanApprovalLeadByPriority } from '../AdminReducer.component';
import { DisburseLead as disburseLeads } from '../AdminReducer.component';
import { ImportantLead as importantLeads } from '../AdminReducer.component';
import { AdminUserReducer as admin } from '../AdminReducer.component';
import { RejectUserReducer as rejectList } from '../AdminReducer.component';
import { StatusReducer as allStatus } from '../AdminReducer.component';
// import { ambasadorDetailsReducer as ambasadorDetails } from '../components/containers/Ambassador/AmbasadorReducer.component';
import { AllAmbassadorDataAdmin as allAmbassadorData } from '../AdminReducer.component';
import { loyalityDetailsReducer as loyalityDetails } from '../AdminReducer.component';
import { activityDataReducer as activityData } from '../AdminReducer.component';
// import { ambasadorAllDetailsReducer as ambassadorAllData } from '../components/containers/Ambassador/AmbasadorReducer.component';
// import { MerchantDataReducer as merchantAllData } from '../components/containers/Merchant/MerchantReducer.component';
import { LeadManagementReducer as leadManagementData } from '../AdminReducer.component';
const reducer = (state = {}, action) => {

	switch (action.type) {

		case 'ADD_EVENTS':
			return {
				...state,
				events: [...action.events]
			};

		case 'LOGIN':

			return {
				...state
			};

		case 'prticipant':

			return {
				...state,
				data: [...action.data]
			}

		case 'LOGOUT':
			return {
				...state,
				userDetails: {}
			};
		default: return state;
	}
};

export default combineReducers({
	allUserDetail,
	duePayment,
	duePaymentEmi,
	CRMMenu,
	incomingPayment,
	latestDocUpload,
	leadByNumber,
	crmNotification,
	loanApprovalLead,
	loanApprovalLeadGiftCard,
	loanApprovalLeadByPriority,
	disburseLeads,
	importantLeads,
	admin,
	rejectList,
	allStatus,
	allAmbassadorData,
	loyalityDetails,
	activityData,
	leadManagementData,
	loanAddaLeadData
});